<template>
  <div class="player-container" dir="rtl">
    <van-icon name="arrow-left" class="back-icon" size="24px" @click="goBack" />
    <div class="video-container">
      <div
        ref="aliplayerContainer"
        id="aliplayerContainer"
        class="aliplayer"
      ></div>

      <!-- 添加全屏按钮 -->
      <!-- <div class="fullscreen-button" @click="toggleFullScreen">
        <van-icon
          :name="isFullScreen ? 'shrink' : 'expand'"
          size="24"
          color="#fff"
        />
      </div> -->
    </div>

    <div
      class="info-bar"
      style="
        background-color: #333;
        color: #fff;
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div>
        <div>
          {{ title }}
        </div>
        <div
          class="episode"
          style="font-size: 0.9em; color: #888; text-align: right"
        >
          جميع الحلقات ( {{ episodes.length }} حلقة) / الحلقة رقم {{ episode }}
        </div>
      </div>
    </div>

    <div class="content-container">
      <div style="margin-bottom: 25px">
        <div style="height: 100px">
          <div class="episode-grid">
            <div
              v-for="(ep, index) in episodes.slice(0, 9)"
              :key="index"
              class="grid-item"
              :class="{
                selected: currentEpisode?.id === ep.id,
                locked: !ep.broadPermit,
              }"
              @click="selectEpisode(ep)"
            >
              {{ ep.index }}
              <van-icon
                v-if="!ep.broadPermit"
                name="lock"
                class="lock-icon"
                style="
                  position: absolute;
                  top: 10px;
                  right: 2px;
                  font-size: 12px;
                "
              />
            </div>
            <div
              v-if="episodes.length > 10"
              class="grid-item more-button"
              @click="showEpisodeSelection = true"
            >
              المزيد
            </div>
            <div
              v-else-if="episodes.length === 10"
              class="grid-item"
              :class="{ selected: episode === episodes[9].index }"
              @click="selectEpisode(episodes[9])"
            >
              {{ episodes[9].index }}
            </div>
          </div>
        </div>
      </div>
      <div class="description" @click.stop>
        <p
          v-if="!isExpanded"
          class="short-description"
          :style="{
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
          }"
        >
          {{ desc }}...
        </p>
        <p v-else class="full-description">{{ desc }}</p>
        <button class="toggle-button" @click.stop="toggleDescription">
          {{ isExpanded ? " إغلاق" : " عرض المزيد" }}
          <span class="arrow">{{ isExpanded ? "↑" : "↓" }}</span>
        </button>
      </div>
      <div class="recommended">
        <h3>أفلام موصى بها</h3>
        <div class="movie-grid">
          <div
            class="movie-card"
            v-for="rec in recommendedMovies"
            :key="rec.id"
            @click="goToPlayerH(rec.id)"
          >
            <img :src="rec.cover" alt="影片封面" />
            <span>{{ rec.title }}</span>
            {{ rec.price }}{{ currency }}
          </div>
        </div>
        <div style="height: 100px"></div>
      </div>
    </div>

    <!-- Popup for episode selection -->
    <van-popup
      v-model="showEpisodeSelection"
      position="bottom"
      :style="{ height: '70%', maxHeight: '70%' }"
    >
      <div class="popup-header">
        <div class="popup-info">
          <h3>{{ title }}</h3>
          <p>عدد الحلقات: {{ episodes.length }}</p>
        </div>
        <img :src="selectedThumbnail" alt="صورة مصغرة" class="thumbnail" />
      </div>
      <van-grid :column-num="4" :gutter="10" style="padding: 0 10px">
        <van-grid-item
          v-for="ep in episodes"
          :key="ep.index"
          :class="{
            'selected-episode': ep.index === episode,
            'locked-episode': !ep.broadPermit,
          }"
          @click.stop="selectEpisode(ep)"
          style="
            margin: 5px;
            flex: 0 0 calc(25% - 10px);
            position: relative;
            max-width: calc(25% - 10px);
            position: relative;
          "
        >
          <span :class="{ 'selected-episode': ep.index === episode }">{{
            ep.index
          }}</span>
          <span v-if="ep === episode" class="playing-indicator">
            <span></span><span></span><span></span>
          </span>

          <div
            v-if="!ep.broadPermit"
            class="overlay"
            style="
              position: absolute;
              top: 0;
              right: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(211, 211, 211, 0.5);
            "
          >
            <van-icon
              v-if="!ep.broadPermit"
              name="lock"
              style="position: absolute; top: 10px; right: 10px"
              @click.stop="selectEpisode(ep)"
            />
          </div>
        </van-grid-item>
      </van-grid>
      <div class="popup-footer"></div>
    </van-popup>

    <van-popup
      v-model="showPaymentPopup"
      position="bottom"
      :style="{ height: '70%', maxHeight: '70%' }"
      @open="setDefaultSelection"
    >
      <div class="payment-popup-content">
        <!-- 支付信息 -->
        <h3 class="payment-title">معلومات الدفع</h3>
        <p class="payment-description">من فضلك قم بالدفع لمشاهدة هذه الحلقة</p>
        <div class="vip-container">
          <!-- 单集购买（始终显示） -->
          <div
            class="vip-card single-episode-card"
            :class="{
              'card-selected': selectedOption?.type === 'single',
            }"
            @click="
              selectOption({
                ...priceInfo?.data,
                price: priceInfo?.data?.price,
                type: 'single',
              })
            "
          >
            <span> شراء حلقة واحدة</span>
            <span class="price-container">
              <span class="price">{{
                priceInfo?.data?.price?.toFixed(2) || "-"
              }}</span>
              <span class="unit">{{ currency }}</span>
            </span>
          </div>

          <!-- 5集套餐（仅当剩余集数>5时显示） -->
          <div
            v-if="remainingEpisodes.length > 5"
            class="vip-card single-episode-card"
            :class="{
              'card-selected': selectedOption?.type === 'five',
            }"
            @click="
              selectOption({
                ...priceInfo?.data5,
                price: priceInfo?.data?.price * 5,
                type: 'five',
              })
            "
          >
            <span> شراء 5 حلقات</span>
            <span class="price-container">
              <span class="price">{{
                (priceInfo?.data?.price * 5)?.toFixed(2) || "-"
              }}</span>
              <span class="unit">{{ currency }}</span>
            </span>
          </div>

          <!-- 动态剩余套餐 -->
          <div
            v-if="
              remainingEpisodes.length > 1 && remainingEpisodes.length <= 10
            "
            class="vip-card single-episode-card"
            :class="{
              'card-selected': selectedOption?.type === 'remaining',
            }"
            @click="
              selectOption({
                price: priceInfo?.data?.price * remainingEpisodes.length,
                count: remainingEpisodes.length,
                type: 'remaining',
              })
            "
          >
            <span>شراء {{ remainingEpisodes.length }} حلقات</span>
            <span class="price-container">
              <span class="price">{{
                (priceInfo?.data?.price * remainingEpisodes.length)?.toFixed(
                  2
                ) || "-"
              }}</span>
              <span class="unit">{{ currency }}</span>
            </span>
          </div>

          <!-- 原10集套餐（仅当剩余集数>10时显示） -->
          <div
            v-if="remainingEpisodes.length > 10"
            class="vip-card single-episode-card"
            :class="{
              'card-selected': selectedOption?.type === 'ten',
            }"
            @click="
              selectOption({
                ...priceInfo?.data10,
                price: priceInfo?.data?.price * 10,
                type: 'ten',
              })
            "
          >
            <span> شراء 10 حلقات</span>
            <span class="price-container">
              <span class="price">{{
                (priceInfo?.data?.price * 10)?.toFixed(2) || "-"
              }}</span>
              <span class="unit">{{ currency }}</span>
            </span>
          </div>
        </div>
        <h4 class="vip-title">شراء عضوية VIP</h4>
        <div class="vip-container">
          <div
            class="vip-card"
            :class="{ 'card-selected': selectedOption?.id === vip.id }"
            @click="selectOption(vip)"
            v-for="vip in priceInfo?.vips"
            :key="vip.id"
          >
            <span class="vip-card-title">{{ vip.info }}</span>
            <span class="price-container">
              <span class="price">{{ vip.price }}</span
              ><span class="unit">{{ currency }}</span>
            </span>
            <div
              class="unit"
              style="text-decoration: line-through; color: rgba(0, 0, 0, 0.5)"
            >
              {{ vip.oldPrice }}
            </div>
          </div>
        </div>
        <h4 class="payment-methods-title">اختر طريقة الدفع</h4>
        <div class="payment-methods">
          <div class="payment-methods-container">
            <div
              class="payment-method-card"
              :class="{ selected: selectedPaymentMethod.id === method.id }"
              @click="selectPaymentMethod(method)"
              v-for="method in paymentMethods"
              :key="method.id"
            >
              <img
                :src="method.img"
                alt="支付方式图标"
                class="payment-method-icon"
              />
            </div>
          </div>
        </div>
        <div class="payment-summary">
          <!-- 待付金额 -->
          <p>
            المبلغ المستحق للدفع:
            <span class="total-amount">{{ totalAmount?.toFixed(2) }}</span>
            {{ currency }}
          </p>
          <button
            class="payment-button custom-payment-button"
            @click="handlePayment"
          >
            <!-- 立即支付 -->
            الدفع الآن
          </button>
        </div>
      </div>
    </van-popup>

    <van-loading
      v-if="loading"
      type="spinner"
      size="24"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    />
  </div>
</template>

<script>
import { Grid, GridItem, Popup, Icon, Toast } from "vant";
import { getUserInfo, getToken } from "@/utils";
import Aliplayer from "aliyun-aliplayer";
import "aliyun-aliplayer/build/skins/default/aliplayer-min.css";

import {
  getMovieDetail,
  getPlayDetail,
  loadMoreMovies,
  getPrice,
  signalOrder,
  vipOrder,
  pay,
  refreshToken,
  makePayment,
} from "../api/api";

export default {
  name: "VideoPlayer",
  components: {
    "van-grid": Grid,
    "van-grid-item": GridItem,
    "van-popup": Popup,
    "van-icon": Icon,
  },
  computed: {
    currency() {
      return getUserInfo()?.currency || "USD";
    },
    token() {
      return getToken();
    },
    remainingCount() {
      return this.remainingEpisodes.length;
    },
  },
  data() {
    return {
      title: "",
      episode: "1",
      touchStartX: 0,
      touchStartTime: 0,
      showPlayButton: true,
      clickTimeout: null,
      showEpisodeSelection: false,
      episodes: [],
      desc: "",
      selectedThumbnail: "",
      currentEpisode: null,
      isExpanded: false,
      fullDescription: "",
      recommendedMovies: [],
      showPaymentPopup: false,
      broadPermit: false,
      loading: false,
      totalAmount: 0,
      selectedOption: null,
      priceInfo: {},
      isFullScreen: false,
      screenOrientation: window.screen.orientation,
      paymentMethods: [],
      selectedPaymentMethod: {},
      aliplayerInstance: null,
      remainingEpisodes: [],
    };
  },
  created() {
    this.fetchMovieDetails();
    this.loadMoreMovies();
  },
  mounted() {
    // 监听全屏变化
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    );

    // 添加屏幕方向变化监听
    if (window.screen.orientation) {
      window.screen.orientation.addEventListener(
        "change",
        this.handleOrientationChange
      );
    }
    setInterval(async () => {
      console.log("刷新token");
      try {
        const res = await refreshToken(); // 刷新token
        if (res.code === "failed") {
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          this.$router.push({
            path: "/login",
            query: { redirect: this.$route.fullPath },
          });
        }
      } catch (error) {
        console.error("刷新token失败:", error);
      }
    }, 6000 * 10 * 10);
  },
  beforeDestroy() {
    if (this.aliplayerInstance) {
      this.aliplayerInstance.dispose();
    }
    // 移除全屏事件监听
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    );

    // 移除屏幕方向变化监听
    if (window.screen.orientation) {
      window.screen.orientation.removeEventListener(
        "change",
        this.handleOrientationChange
      );
    }
  },
  methods: {
    toggleDescription(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isExpanded = !this.isExpanded;
      // 确保选集弹窗不会被触发
    },
    handleClick() {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);
        this.clickTimeout = null;
      } else {
        this.clickTimeout = setTimeout(() => {
          this.clickTimeout = null;
        }, 300);
      }
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartTime = event.timeStamp;
    },
    handleTouchMove(event) {
      const touchEndX = event.touches[0].clientX;
      const deltaX = touchEndX - this.touchStartX;
      const video = this.$refs.videoPlayer;
      const duration = video.duration;
      const newTime =
        video.currentTime + (deltaX / window.innerWidth) * duration;
      video.currentTime = Math.min(Math.max(newTime, 0), duration);
    },
    handleTouchEnd(event) {
      const touchDuration = event.timeStamp - this.touchStartTime;
      if (touchDuration < 500) {
        return;
      }
    },
    async selectEpisode(ep) {
      this.episode = ep.index;
      this.broadPermit = ep.broadPermit;
      console.log("选择的集数:", ep.index);

      // 显示加载提示
      Toast.loading({
        message: "执行中...",
        forbidClick: true,
      });
      // 先获取播放详情
      const playResponse = await getPlayDetail(ep.id, ep.currency);
      this.currentEpisode = playResponse.data;
      this.broadPermit = playResponse.data.broadPermit;

      const priceResponse = await getPrice(this.currentEpisode.id);
      console.log("当前集信息:", playResponse);
      if (!priceResponse.data?.broadPermit) {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        // 新增回切第一集逻辑
        this.priceInfo = {
          data: priceResponse.data,
          vips: priceResponse.vips,
        };
        console.log("priceResponse.data============", priceResponse.data);
        this.selectedOption = priceResponse.data;
        this.totalAmount = priceResponse.data?.price;
        this.$set(this.priceInfo);
      }
      this.remainingEpisodes = this.episodes.filter(
        (ep) => ep.broadPermit == false
      );
      console.log("this.episodes", this.episodes);
      // 关闭选择弹窗
      setTimeout(() => {
        if (!this.broadPermit) {
          this.showPaymentPopup = true;
        }
        // 清除加载提示
        Toast.clear();
      }, 200);
      console.log("currentEpisode:", this.currentEpisode);
      // 更新播放源
      if (this.aliplayerInstance && this.currentEpisode?.viedoUrl_H) {
        this.aliplayerInstance.loadByUrl(this.currentEpisode.viedoUrl_H);
      }
    },
    fetchMovieDetails() {
      const movieId = this.$route.query.id;
      if (movieId) {
        this.getMovieDetail(movieId);
      } else {
        console.error("未找到电影ID");
      }
    },
    async getMovieDetail(movieId) {
      try {
        const response = await getMovieDetail(movieId);
        console.log("response====?", response);
        this.title = response.data.title;
        this.episodes = response.data.chapters;
        this.desc = response.data.desc;
        this.fullDescription = response.data.fullDesc;
        this.selectedThumbnail = response.data.cover;

        // 先获取播放详情再初始化播放器
        if (this.episodes.length > 0) {
          const firstEpisode = this.episodes[0];
          const playResponse = await getPlayDetail(firstEpisode.id);
          this.currentEpisode = playResponse.data;

          // 确保有视频地址后再初始化播放器
          if (this.currentEpisode?.viedoUrl_H) {
            if (!this.aliplayerInstance) {
              this.initAliplayer();
            } else {
              this.aliplayerInstance.loadByUrl(this.currentEpisode.viedoUrl_H);
            }
          }
        }

        const makePaymentResponse = await makePayment();
        console.log("makePaymentResponse", makePaymentResponse.data);
        this.paymentMethods = makePaymentResponse.data;
        this.selectedPaymentMethod = this.paymentMethods[0];
      } catch (error) {
        console.error("获取影片详情失败:", error);
      }
    },
    async loadMoreMovies() {
      try {
        const response = await loadMoreMovies(1, 6);
        this.recommendedMovies = response.data;
      } catch (error) {
        console.error("加载推荐影片失败:", error);
      }
    },
    goToPlayerH(movieId) {
      this.getMovieDetail(movieId);
    },
    async handlePayment() {
      this.showPaymentPopup = false;
      Toast.loading({
        message: "支付中...",
        forbidClick: true,
      });
      console.log("this.--------------------------->", this.remainingEpisodes);
      let ids = [];
      if (this.selectedOption?.type === "single") {
        // 单集购买，只传当前剧集ID
        ids = [this.currentEpisode.id];
      } else if (this.selectedOption?.type === "remaining") {
        // 多集购买，按照剩余剧集顺序取指定数量的剧集ID
        const packageEpisodes = this.remainingEpisodes.map((ep) => ep.id);
        ids = packageEpisodes;
      } else if (this.selectedOption?.type === "five") {
        // 5集套餐，传当前+后续4集ID
        const packageEpisodes = this.remainingEpisodes
          .slice(0, 5)
          .map((ep) => ep.id);
        ids = packageEpisodes;
      } else if (this.selectedOption?.type === "ten") {
        // 10集套餐，传当前+后续9集ID
        const packageEpisodes = this.remainingEpisodes
          .slice(0, 10)
          .map((ep) => ep.id);
        ids = packageEpisodes;
      }
      console.log("ids", ids);
      console.log("this.selectedOption", this.selectedOption);
      if (
        this.selectedOption.type === "single" ||
        this.selectedOption.type === "remaining" ||
        this.selectedOption.type === "five" ||
        this.selectedOption.type === "ten"
      ) {
        console.log("--------------------------------", ids);
        const signalOrderResponse = await signalOrder(ids);
        console.log("信号订单结果:", signalOrderResponse);

        const payResponse = await pay(
          signalOrderResponse.data.oId,
          this.selectedPaymentMethod.id
        );
        console.log("支付结果:", payResponse);
        window.location.href = payResponse;
      } else {
        const vipOrderResponse = await vipOrder(
          this.selectedOption.id,
          this.currentEpisode.id,
          this.currency
        );
        console.log("vip订单结果:", vipOrderResponse);
        const payResponse = await pay(
          vipOrderResponse.data.oId,
          this.selectedPaymentMethod.id
        );
        console.log("payResponse", payResponse);
        window.location.href = payResponse;
      }
    },
    selectOption(option) {
      console.log("selectOption", option);
      this.selectedOption = {
        id: option.id,
        price: option.price,
        type: option.type,
        count: option.count, // 添加count字段用于动态套餐
      };
      this.totalAmount = option.price;
    },
    goBack() {
      this.$router.push({ path: "/" });
    },
    async handleVideoEnded() {
      const currentIndex = this.episodes.findIndex(
        (ep) => ep.index === this.episode
      );
      const nextEpisode = this.episodes[currentIndex + 1];

      if (nextEpisode) {
        const wasFullScreen = this.isFullScreen;
        await this.selectEpisode(nextEpisode);

        // 自动播放新加载的视频
        if (this.aliplayerInstance) {
          this.aliplayerInstance.play();
        }

        // 保持全屏状态
        if (wasFullScreen && !this.isFullScreen) {
          setTimeout(() => this.toggleFullScreen(), 300);
        }
      } else {
        Toast("已经是最后一集了");
      }
    },
    // 切换全屏状态
    toggleFullScreen() {
      if (this.aliplayerInstance) {
        try {
          // 优先使用播放器自带的API
          if (typeof this.aliplayerInstance.requestFullScreen === "function") {
            this.aliplayerInstance.requestFullScreen();
          } else {
            // 浏览器原生全屏API
            const container = this.$refs.aliplayerContainer;
            if (container) {
              if (container.requestFullscreen) {
                container.requestFullscreen();
              } else if (container.mozRequestFullScreen) {
                /* Firefox */
                container.mozRequestFullScreen();
              } else if (container.webkitRequestFullscreen) {
                /* Chrome, Safari and Opera */
                container.webkitRequestFullscreen();
              } else if (container.msRequestFullscreen) {
                /* IE/Edge */
                container.msRequestFullscreen();
              }
            }
          }
          // iOS特殊处理
          if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
            const videoElement = this.aliplayerInstance.getVideoElement();
            if (videoElement && videoElement.webkitEnterFullscreen) {
              videoElement.webkitEnterFullscreen();
            }
          }
        } catch (error) {
          console.error("全屏切换失败:", error);
          Toast.fail("全屏切换失败");
        }
      }
    },
    // 处理全屏状态变化
    handleFullscreenChange() {
      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (isIOS) {
        this.isFullScreen =
          this.$refs.videoPlayer?.webkitDisplayingFullscreen || false;
      } else {
        this.isFullScreen = Boolean(
          document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement
        );
      }

      // 处理方向变化
      if (
        !this.isFullScreen &&
        this.screenOrientation &&
        this.screenOrientation.unlock
      ) {
        this.screenOrientation.unlock();
      }
    },
    handleOrientationChange() {
      // 处理方向变化
      if (
        !this.isFullScreen &&
        this.screenOrientation &&
        this.screenOrientation.unlock
      ) {
        this.screenOrientation.unlock();
      }
    },
    initAliplayer() {
      this.aliplayerInstance = new Aliplayer({
        license: {
          domain: "video.thatsbooks.com", // 申请 License 时填写的域名
          key: "GPhovqMDhyi52uZVQdb4278da9ca54172b67d0d3ad1bdd773", // 申请成功后，在控制台可以看到 License Key
        },
        id: "aliplayerContainer",
        autoplay: true,
        muted: true,
        isLive: false,
        playsinline: true,
        preload: true,
        showBarTime: 3000,
        controlBarVisibility: "click",
        useH5Prism: true,
        enableSystemMenu: true,
        skinLayout: [
          { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
          { name: "H5Loading", align: "cc" },
          { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
          { name: "infoDisplay" },
          { name: "tooltip", align: "blabs", x: 0, y: 56 },
          { name: "thumbnail" },
          {
            name: "controlBar",
            align: "blabs",
            x: 0,
            y: 0,
            children: [
              { name: "progress", align: "blabs", x: 0, y: 44 },
              { name: "playButton", align: "tl", x: 15, y: 12 },
              { name: "timeDisplay", align: "tl", x: 10, y: 7 },
              { name: "fullScreenButton", align: "tr", x: 10, y: 12 },
              { name: "subtitle", align: "tr", x: 15, y: 12 },
              { name: "setting", align: "tr", x: 15, y: 12 },
              { name: "volume", align: "tr", x: 5, y: 10 },
            ],
          },
        ],
        source: this.currentEpisode.viedoUrl_H, // 添加初始视频源
      });

      // 添加错误处理
      this.aliplayerInstance.on("error", (error) => {
        console.error("播放器错误:", error);
        Toast.fail("视频加载失败");
      });

      // 添加播放结束监听
      this.aliplayerInstance.on("ended", this.handleVideoEnded);
    },
    // 新增方法：设置默认选中
    setDefaultSelection() {
      const options = [];
      const singlePrice = this.priceInfo?.data?.price || 0;
      const remainingCount = this.remainingEpisodes.length;

      // 单集选项
      options.push({
        type: "single",
        price: singlePrice,
        priority: 1,
      });

      // 5集套餐
      if (remainingCount > 5) {
        options.push({
          type: "five",
          price: singlePrice * 5,
          priority: 2,
        });
      }

      // 动态剩余套餐
      if (remainingCount > 1 && remainingCount <= 10) {
        options.push({
          type: "remaining",
          price: singlePrice * remainingCount,
          priority: 3,
        });
      }

      // 10集套餐
      if (remainingCount > 10) {
        options.push({
          type: "ten",
          price: singlePrice * 10,
          priority: 4,
        });
      }

      // 找到金额最大的选项（金额相同则按优先级排序）
      const maxOption = options.sort((a, b) => {
        if (b.price === a.price) {
          return b.priority - a.priority; // 金额相同时选择优先级高的（套餐越大优先级越高）
        }
        return b.price - a.price;
      })[0];

      // 设置选中状态
      if (maxOption) {
        this.selectOption({
          ...this.getOptionData(maxOption.type),
          type: maxOption.type,
          price: maxOption.price,
        });
      }
    },

    // 辅助方法：获取对应套餐的原始数据
    getOptionData(type) {
      switch (type) {
        case "single":
          return this.priceInfo?.data || {};
        case "five":
          return this.priceInfo?.data5 || {};
        case "ten":
          return this.priceInfo?.data10 || {};
        case "remaining":
          return { count: this.remainingEpisodes.length };
        default:
          return {};
      }
    },
  },
  watch: {
    token() {},
  },
};
</script>

<style scoped>
.player-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  direction: rtl;
  text-align: right;
}

.video-container {
  position: relative;
  width: 100%;
  height: calc(100vw * 9 / 16);
  background: #000;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  opacity: 0.9;
  transition: opacity 0.3s;
}

.play-button:hover {
  opacity: 1;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
  -webkit-transform-style: preserve-3d;
}

.info-bar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  background: rgb(76, 175, 80);
  color: #ffffff;
  font-weight: bold;
}

.description {
  padding: 15px 20px;
  border-top: 1px solid #ced4da;
  overflow: hidden;
  text-align: right;
}

.short-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.full-description {
  overflow: hidden;
  max-height: none;
}

.toggle-button {
  margin-top: 10px;
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #000000;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle-button:hover {
  background-color: #f0f0f0;
}

.recommended {
  padding: 15px 20px;
}

.movie-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  grid-auto-rows: minmax(100px, auto);
}

.movie-card {
  background: #fff;
  border-radius: 5px;
  text-align: right;
}

.movie-card img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.popup-header {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ced4da;
  margin-bottom: 20px;
  flex-direction: row-reverse;
}

.thumbnail {
  width: 60px;
  height: 60px;
  margin-left: 15px;
  margin-right: 0;
  border-radius: 5px;
  object-fit: cover;
  flex-shrink: 0;
}

.popup-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-info h3 {
  margin: 0;
  font-size: 18px;
  color: #343a40;
}

.popup-info p {
  margin: 5px 0 0;
  font-size: 14px;
  color: #6c757d;
}

::v-deep .selected-episode {
  color: #007bff;
  font-weight: bold;
}

.playing-indicator {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 16px;
  height: 12px;
  position: absolute;
  top: 5px;
  left: 5px;
}

.playing-indicator span {
  display: block;
  width: 3px;
  background-color: #ffc107;
  animation: bounce 1s infinite ease-in-out;
}

.playing-indicator span:nth-child(1) {
  animation-delay: 0s;
}

.playing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.playing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%,
  100% {
    height: 2px;
  }
  50% {
    height: 12px;
  }
}

.popup-footer {
  height: 50px;
}

.content-container {
  overflow-y: auto;
  flex: 1;
  height: calc(100vh - 60px);
}
.episode {
  text-align: right;
  font-weight: 400;
}

.popup-content {
  overflow-y: auto;
}

.locked-episode {
  background-color: rgba(211, 211, 211, 0.5); /* 灰色背景 */
  position: relative; /* 使锁图标相对定位 */
}

.lock-icon {
  position: absolute; /* 绝对定位 */
  top: 80%; /* 垂直居中 */
  right: 10px; /* 调整位置 */
  transform: translate(-50%, -50%); /* 使图标居中 */
}

.overlay {
  position: absolute; /* 绝对定位 */
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(211, 211, 211, 0.5); /* 半透明灰色背景 */
  z-index: 1; /* 确保遮罩在上层 */
}

.payment-popup-content {
  padding: 10px;
  background-color: #ffffff;
  text-align: right;
}

.payment-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.payment-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.payment-button {
  width: 100%;
  padding: 12px; /* 增加内边距 */
  margin: 10px 0; /* 增加上下间距 */
  background-color: rgb(149, 236, 105); /* 浅绿色 */
  color: #000000; /* 黑色文字 */
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.payment-button:hover {
  background-color: rgb(76, 175, 80); /* 悬停时更深的绿色 */
}

.vip-title {
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0 10px;
  color: #333;
}

.close-button {
  background-color: #f44336;
  color: white;
}

.close-button:hover {
  background-color: #d32f2f;
}

.vip-container {
  display: flex;
  box-sizing: border-box;
  position: relative;
}

.vip-card {
  flex: 1 1 0; /* 确保每个子{{currency}}素平分空间并允许缩放 */
  margin: 0 5px; /* 添加左右间距 */
  padding: 20px 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  text-align: right;
  background-color: rgb(76, 175, 80);
  box-sizing: border-box;
  border: 3px solid white;
}

.vip-card:nth-child(1) {
  background: linear-gradient(
    to bottom,
    rgb(76, 175, 80),
    rgba(224, 247, 250, 0)
  );
  color: #333;
}

.vip-card:nth-child(2) {
  background: linear-gradient(
    to bottom,
    rgb(76, 175, 80),
    rgba(165, 214, 167, 0)
  );
}

.vip-card:nth-child(3) {
  background: linear-gradient(
    to bottom,
    rgb(76, 175, 80),
    rgba(200, 230, 201, 0)
  );
  color: #333;
}

.vip-card span {
  display: block;
  font-size: 20px;
  margin-bottom: 5px;
}

.price {
  font-weight: bold;
  font-size: 16px !important;
  color: #333;
}

.unit {
  font-size: 12px !important;
  color: #333;
  margin-right: 5px;
  margin-left: 0;
}

.price-container {
  display: flex !important;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row-reverse;
}

.vip-card-title {
  color: rgba(255, 255, 255, 0.8); /* 更浅的标题颜色 */
  font-size: 14px !important; /* 更小的字体大小 */
  margin-bottom: 10px !important; /* 增加底部间距 */
}

.custom-payment-button {
  background-color: #4caf50; /* 修改为您想要的颜色 */
  color: white; /* 按钮文字颜色 */
}

.custom-payment-button:hover {
  background-color: #45a049; /* 悬停时的颜色 */
}

.selected {
  background-color: #007bff;
  color: white;
}

.vip-card.selected {
  border: 2px solid #4caf50; /* 选中时的边框颜色 */
  background-color: rgba(76, 175, 80, 0.1); /* 选中时的背景颜色 */
}

.single-episode-card.selected {
  border: 2px solid #4caf50; /* 选中时的边框颜色 */
  background-color: rgba(76, 175, 80, 0.1); /* 选中时的背景颜色 */
}
.total-amount {
  font-weight: bold;
  font-size: 22px;
}

.toggle-button .arrow {
  transform: scaleX(-1);
}

.back-button {
  background-color: #007bff; /* 按钮颜色 */
  color: white; /* 按钮文字颜色 */
  border: none;
  border-radius: 5px;
  padding: 12px 20px; /* 增加内边距 */
  cursor: pointer;
  margin: 10px; /* 添加一些外边距 */
  font-size: 16px; /* 增加字体大小 */
  transition: background-color 0.3s; /* 添加过渡效果 */
}
.back-button:hover {
  background-color: #0056b3; /* 悬停时的颜色 */
}

.back-icon {
  position: absolute;
  top: 20px;
  right: 10px;
  cursor: pointer;
  z-index: 100;
  transform: rotate(180deg);
}

@media (min-width: 1024px) {
  .player-container {
    flex-direction: row; /* 在电脑端使用行布局 */
  }

  .video-player {
    width: 70%; /* 视频播放器占70%宽度 */
    height: auto; /* 高度自适应 */
  }

  .content-container {
    width: 30%; /* 内容容器占30%宽度 */
    padding: 20px; /* 添加内边距 */
    overflow-y: auto; /* 允许垂直滚动 */
  }

  .info-bar {
    position: static; /* 在电脑端取消固定定位 */
    background: rgba(76, 175, 80, 0.8); /* 背景透明度调整 */
  }

  .recommended {
    padding: 20px; /* 增加推荐影片的内边距 */
  }

  .movie-grid {
    grid-template-columns: repeat(4, 1fr); /* 在电脑端使用4列布局 */
  }
}

.current-episode {
  background-color: rgba(76, 175, 80, 0.3); /* 设置背景颜色 */
  border: 2px solid #4caf50; /* 设置边框颜色 */
  color: #ffffff; /* 设置文字颜色 */
}

.card-selected {
  border: 3px solid #4caf50 !important;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
  position: relative;
}

.card-selected::after {
  content: "✓";
  position: absolute;
  top: 10px;
  left: 10px;
  background: #4caf50;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: white;
  font-weight: 900;
}

.vip-card,
.single-episode-card {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.vip-card:hover,
.single-episode-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 确保Android全屏时控件正确显示 */
.fullscreen-button {
  z-index: 10000;
}

.payment-methods {
  overflow-x: auto; /* 允许横向滚动 */
  white-space: nowrap; /* 防止换行 */
  margin-top: 20px;
}

.payment-methods-title {
  margin-bottom: 10px; /* 标题与支付方式之间的间距 */
}

.payment-methods-container {
  display: inline-flex; /* 使用inline-flex以支持横向排列 */
  gap: 10px; /* 卡片之间的间距 */
}

.payment-method-card {
  width: 80px; /* 设置固定宽度 */
  height: 80px; /* 设置固定高度 */
  background-color: #f9f9f9; /* 卡片背景色 */
  border: 1px solid #e0e0e0; /* 边框 */
  border-radius: 8px; /* 圆角 */
  display: flex; /* 使用flex布局 */
  align-items: center; /* 垂直居中对齐 */
  justify-content: center; /* 水平居中对齐 */
  cursor: pointer; /* 鼠标悬停时显示为可点击 */
  transition: transform 0.3s, box-shadow 0.3s; /* 动画效果 */
}

::v-deep(.selected) {
  border-color: #4caf50; /* 选中时的边框颜色 */
  background-color: #e0f7e0; /* 选中时的背景颜色 */
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3); /* 选中时的阴影效果 */
}

.payment-method-icon {
  width: 60px; /* 调整图标宽度 */
  height: 60px; /* 调整图标高度 */
  object-fit: contain; /* 确保图片不被拉伸 */
}

.aliplayer {
  width: 100%;
  height: 100% !important;
  background: #000;
}

.aliplayer >>> video {
  /* 这行也可以移除，因为我们想要允许所有交互 */
  /* pointer-events: auto; */
}

/* 移除这些样式，让播放器控制栏可见 */
/* ::v-deep .prism-controlbar,
::v-deep .prism-play-btn,
::v-deep .prism-time-display,
::v-deep .prism-fullscreen-btn,
::v-deep .prism-volume {
  display: none !important;
} */

.episode-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 50px;
  gap: 8px;
  padding: 10px;
  max-width: 400px;
  margin: 0 auto;
}

.grid-item {
  height: 50px;
  max-width: 80px;
  width: 100%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.grid-item:hover {
  background: #e0e0e0;
}

.more-button {
  background: #4caf50;
  color: white;
}

@media (max-width: 375px) {
  .episode-grid {
    grid-auto-rows: 40px;
    gap: 5px;
    padding: 8px;
  }

  .grid-item {
    height: 40px;
    max-width: 40px;
    font-size: 12px;
  }
}

.grid-item.selected {
  color: white;
  background: #4caf50;
  font-weight: bold;
}

.grid-item.locked {
  background: #e0e0e0;
  position: relative;
  opacity: 0.7;
}

.lock-icon {
  color: #666;
  pointer-events: none; /* 防止图标阻挡点击事件 */
}
</style>